export const LOGO_URL = "https://customer-assets.emergentagent.com/job_d8505cdc-0c1a-4d30-90e6-e00163fb79fa/artifacts/qcpat8n3_Reading%20Physio%20logo.png";

export const CONTACT = {
  phone: "07804200419",
  phoneDisplay: "07804 200 419",
  email: "info@reading-physio.co.uk",
  address: "29 Bromley Walk, Reading, RG30 4LR",
  hoursWeek: "Mon – Fri: 7:00 AM – 9:00 PM",
  hoursHome: "Home visits available 7 days a week",
};

export const NAV_LINKS = [
  { id: "about", label: "About" },
  { id: "services", label: "Services" },
  { id: "team", label: "Team" },
  { id: "pricing", label: "Pricing" },
  { id: "testimonials", label: "Reviews" },
  { id: "faq", label: "FAQ" },
  { id: "contact", label: "Contact" },
];
